import { ClockIcon, GSFlame, ImageIcon } from 'assets/icons';
import { VaultNavigationTabs } from 'common/enums';
import { ReactNode } from 'react';

interface NavigationTabs {
  name: string;
  icon: ReactNode;
  tab: VaultNavigationTabs;
}
export const navigationTabs: NavigationTabs[] = [
  {
    name: 'Dashboard',
    icon: <GSFlame />,
    tab: VaultNavigationTabs.dashboard,
  },
  {
    name: 'Albums',
    icon: <ImageIcon />,
    tab: VaultNavigationTabs.albums,
  },
  {
    name: 'Memories',
    icon: <ImageIcon />,
    tab: VaultNavigationTabs.memories,
  },
  {
    name: 'Timeline',
    icon: <ClockIcon />,
    tab: VaultNavigationTabs.timeline,
  },
];
